const notification = (message, type = 'info', duration = 4500) => {
  if (!message) return;

  const notificationEl = document.createElement('div');
  notificationEl.className = `notification notification--${type}`;
  notificationEl.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
    padding: 16px 24px;
    display: flex;
    align-items: center;
    pointer-events: auto;
    transform: translateX(100%);
    transition: transform 0.3s ease, top 0.3s ease;
    border-left: 4px solid;
    z-index: 10000;
  `;

  const colors = {
    success: '#52c41a',
    info: '#1890ff',
    warning: '#faad14',
    error: '#ff4d4f'
  };
  notificationEl.style.borderLeftColor = colors[type] || colors.info;

  const icon = document.createElement('div');
  icon.style.cssText = `
    margin-right: 12px;
    font-size: 20px;
    display: flex;
    align-items: center;
    color: #333;
  `;
  const icons = {
    success: '✓',
    info: 'ℹ',
    warning: '⚠',
    error: '✕'
  };
  icon.textContent = icons[type] || icons.info;
  notificationEl.appendChild(icon);

  const messageEl = document.createElement('div');
  messageEl.style.cssText = `
    flex: 1;
    font-size: 14px;
    line-height: 1.5;
    color: #333;
  `;
  messageEl.textContent = message;
  notificationEl.appendChild(messageEl);

  const closeBtn = document.createElement('button');
  closeBtn.style.cssText = `
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    margin-left: 12px;
    color: #999;
    display: flex;
    align-items: center;
  `;
  closeBtn.innerHTML = '×';
  closeBtn.onclick = () => removeNotification(notificationEl);
  notificationEl.appendChild(closeBtn);

  document.body.appendChild(notificationEl);

  activeNotifications.push(notificationEl);
  repositionNotifications();

  setTimeout(() => {
    notificationEl.style.transform = 'translateX(0)';
  }, 10);

  if (duration > 0) {
    setTimeout(() => removeNotification(notificationEl), duration);
  }
};

const activeNotifications = [];

const repositionNotifications = () => {
  activeNotifications.forEach((el, index) => {
    el.style.top = `${20 + index * 70}px`;
  });
};

const removeNotification = (el) => {
  const index = activeNotifications.indexOf(el);
  if (index > -1) {
    activeNotifications.splice(index, 1);
  }
  el.style.transform = 'translateX(100%)';
  setTimeout(() => {
    if (el.parentNode) el.parentNode.removeChild(el);
    repositionNotifications();
  }, 300);
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = notification;
} else {
  window.notification = notification;
}
